import { type HTMLAttributes, type ReactElement, type ReactNode } from "react";
import { cn } from "@/lib/utils";

interface Props extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode;
}

/**
 * The editorial mono eyebrow that sits above a display heading, e.g.
 * `CRM · ACCOUNTS`. {@link H1} and {@link H2} render it through their
 * `eyebrow` prop; use it directly only when the heading row needs a layout
 * the prop cannot express (a title with badges beside it, for instance).
 */
export function Eyebrow({ children, className, ...rest }: Props): ReactElement {
    return (
        <div
            className={cn("font-mono text-[10.5px] uppercase tracking-[0.14em] text-muted-foreground", className)}
            {...rest}
        >
            {children}
        </div>
    );
}
